import { searchService, type YouParkSearchResult } from "./searchService";

export interface QuickNavYouParkResult {
  type: "youpark";
  organizationId: string;
  organizationName: string;
  lotNames: string[];
}

export type QuickNavResult = QuickNavYouParkResult;

const toQuickNavYouParkResult = (result: YouParkSearchResult): QuickNavYouParkResult | null => {
  if (!result.organizationId) {
    return null;
  }

  return {
    type: "youpark",
    organizationId: result.organizationId,
    organizationName: result.organizationName,
    lotNames: result.lots.map(lot => lot.name)
  };
};

export const quickNavService = {
  async searchAll(query: string): Promise<QuickNavResult[]> {
    try {
      const results = await searchService.searchYouPark(query);
      const mapped = results.map(toQuickNavYouParkResult).filter((r): r is QuickNavYouParkResult => r !== null);

      const byOrgId = new Map<string, QuickNavYouParkResult>();
      for (const result of mapped) {
        const existing = byOrgId.get(result.organizationId);
        if (existing) {
          existing.lotNames.push(...result.lotNames);
        } else {
          byOrgId.set(result.organizationId, { ...result, lotNames: [...result.lotNames] });
        }
      }

      return Array.from(byOrgId.values());
    } catch {
      return [];
    }
  }
};
